import Vue from 'vue'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

Vue.use(FloatingVue, {
  themes: {
    tooltip: {
      container: '.insights-layout',
      placement: 'bottom',
      distance: 10,
      html: true,
      preventOverflow: false,
      arrowOverflow: true
    },

    'tooltip-card': {
      $extend: 'tooltip',
      distance: -25
    },

    'tooltip-left': {
      $extend: 'tooltip',
      placement: 'left'
    },

    'tooltip-right': {
      $extend: 'tooltip',
      placement: 'right'
    },

    'tooltip-top-left': {
      $extend: 'tooltip',
      placement: 'top'
    },

    'tooltip-top-right': {
      $extend: 'tooltip',
      placement: 'top'
    }
  }
})
